import * as React from 'react';

function SvgCalendar(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4.389H4a.5.5 0 00-.5.5V16a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V4.889a.5.5 0 00-.5-.5zm-12-1.5a2 2 0 00-2 2V16a2 2 0 002 2h12a2 2 0 002-2V4.889a2 2 0 00-2-2H4z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 1.4a.75.75 0 01.75.75v3a.75.75 0 11-1.5 0v-3a.75.75 0 01.75-.75zM13.85 1.4a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zM17.111 8.5H2.89V7H17.11v1.5z"
        fill={props.color}
      />
      <path
        d="M6 10.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM6 13.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM9 13.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM12 13.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM9 10.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM12 10.95a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgCalendar;
